/*eslint no-script-url: 0 */
import React, { Component } from "react";
import { Tab, Nav, NavItem } from 'react-bootstrap';

class AdditionalInfo extends Component {
  	render() {
	    return (
	    	<div className="frame_desc full_width">
				<div className="container">
					<div className="row">
						<div className="col-sm-12">
							<Tab.Container defaultActiveKey="faqs" id="tab-container-info">
								<div>
									<div className="top_tab_nav">
										<Nav bsStyle="tabs">
											<NavItem eventKey="faqs">How to Order/FAQS</NavItem>
											<NavItem eventKey="description">Product Description</NavItem>
											<NavItem eventKey="shipping">Shipping & Returns</NavItem>
										</Nav>
									</div>
									<div className="top_tab_cont">
										<Tab.Content>
 											<Tab.Pane eventKey="faqs">
												<p>If you need help navigating our custom picture framing page, please follow the below steps:</p>
												<ol>
													<li>Enter the custom picture frame builder.</li>
													<li>Enter image size located in the top right hand corner of the page. (width x Height)</li>
													<li>If you would like to see how the frame would look like with your image or would like it printed with your frame, upload the image. For an empty frame simply skip this step.</li>
													<li>Select your desired frame which are sorted by colour. Please be mindful of the width and details of the frame before proceeding, all frame information can be found by clicking on frame details.</li>
													<li>Select the Mats option if you would like to add a matt board to your frame. Select the colour and number of Matts required and enter the desired size using the drop down menu. Skip this step if you would like a frame that does not have a matt board around your image.</li>
													<li>Select an option of glass to protect your image, clear glass, Perspex and non reflective glass using the glass option. If you require no glass simply select none.</li>
													<li>If you would like your image printed with your frame please make sure you have uploaded your image in step 3. Select between Matt, High Gloss or Metallic photo paper using the printing option.</li>
													<li>You can view your completed work of art against your wall colour or a photo of a room using our room view options.</li>
													<li>Once complete, you can use the quick save option to save your current frame for comparison to other frames. </li>
													<li>To complete your purchase, add the frame to cart or click the buy it now button to proceed to check out.</li>
													<li>Have fun and be creative!</li>
												</ol>
									        </Tab.Pane>
									       	<Tab.Pane eventKey="description">
												<h5>Picture Frames</h5>

												<p>Picture frames have traditionally been made of wood, which is still the most common material, although other materials used include plastic, synthetic resin and aluminium. At Just Picture Framing we use the highest quality timber frame mouldings made 100% from premium wood mouldings supplied from Australia and New Zealand’s leading manufacturers. Choose from a variety of coloursand textures ranging from simple black and white frames to more detailed mouldings such as our gold frames antique frames.</p>

												<p>Just Picture Framing has over 150 frames to choose from and can source any type of frame if requested.</p>

												<h5>Mat Boards</h5>

												<p>Choose from over 50 colours of mat boards found on our website or email us if you can’t find what you are after.</p>

												<p>Just Picture Framing uses only the best Mat Boards on the market. All our Mat Boards have a bright white core, Buffered to a pH of 7.5 to 9.5 and a  smooth white bevel that will not turn brown over time. All our mats are Acid Free which removes the possibility of Mat Burns. Acidic mats can cause what is called mat burn, brown marks that creep in from the outside onto the displayed piece itself and can damage your precious artwork.</p>

												<h5>Glass & Perspex</h5>

												<p>Your picture frame can be made to contain either glass or Perspex to protect the picture. In some instances where the art in the frame is textured or durable, no protection may be necessary. Glass is common over photos, prints and objects and other, but rare over oil paintings. You can also choose our non-reflective option of glass to eliminate the reflection often seen on frames in rooms with a lot of natural light which can distract from the image. Perspex is a good option for a light weight, safe and durable option especially recommended for frames displayed in public areas.</p>

									        </Tab.Pane>
									        <Tab.Pane eventKey="shipping">
									       		<p>From the day your order is processed Just Picture Framing aims to have your order shipped out within 3-5 working days. If your picture frame is required urgently please contact us.</p>
												<p>Every order is packaged using 2 x of bubble wrap, a small bubble wrap and then a large air patched bubble wrap ensuring that the item is impact resistance. We then package all our photo frames in custom made boxes to ensure extra protection.</p>
												<p><strong>You are required to check the frame before signing the received slip to be covered for insurance.</strong></p>
												<p>All our photo frames are shipped using Fastway courier and Registered Australia Post so we are covered by insurance and can always replace the item if it is damaged (See out postage page on the website for more details).</p>
												<p>You can be confident when purchasing from us that your frame will arrive at its destination in good condition.</p>
												<p><strong>PLEASE NOTE: Items must be inspected for damages prior to signing received slip from courier to be covered by insurance.</strong></p>
									        </Tab.Pane>
									    </Tab.Content>
									</div>
								</div>
							</Tab.Container>
						</div>
					</div>
				</div>
			</div>
	    );
  	}
}

export default AdditionalInfo;